import type { Directive, DirectiveBinding } from 'vue';

type OutsideClickElement = HTMLElement & {
	__outsideClickHandler__?: (event: PointerEvent) => void;
};

export const vClickOutside: Directive<HTMLElement, () => void> = {
	mounted(el: OutsideClickElement, binding: DirectiveBinding<() => void>) {
		el.__outsideClickHandler__ = (event: PointerEvent) => {
			const target = event.target;
			if (!(target instanceof Node) || el.contains(target)) {
				return;
			}

			binding.value();
		};

		document.addEventListener('pointerdown', el.__outsideClickHandler__);
	},
	unmounted(el: OutsideClickElement) {
		if (el.__outsideClickHandler__) {
			document.removeEventListener('pointerdown', el.__outsideClickHandler__);
		}
	},
};
